<template>
    <div class="SideMenuLinks" :class="{ menuActive: isActive }">
        <div class="SideMenuLinks__links">
            <p @click="goToPage('početna')">{{ $t('MenuLinkHome') }}</p>
            <p @click="goToPage('usluge')">{{ $t('MenuLinkServices') }}</p>
            <p @click="goToPage('galerija')">{{ $t('MenuLinkGallery') }}</p>
            <p @click="goToPage('reference')">{{ $t('MenuLinkReferences') }}</p>
            <p @click="goToPage('kontakt')">{{ $t('MenuLinkContact') }}</p>
        </div>
		<div class="SideMenuLinks__lang">
			<div @click="setActiveLanguage('bs')" :class="{ activeLang: activeLanguage === 'bs'}">
				<img src="@/assets/images/bosnia-flag.png">
			</div>
			<div @click="setActiveLanguage('de')" :class="{ activeLang: activeLanguage === 'de'}">
				<img src="@/assets/images/german-flag.png">
			</div>
		</div>
    </div>
</template>

<script>

export default {
    name: 'SideMenuLinks',
    props: {
        isActive: {
            type: Boolean,
            required: true
        },
        menuToggler: Function
	},
	data() {
		return {
			activeLanguage: 'bs'
		}
	},
	watch: {
        activeLanguage(lang) {
            this.$i18n.set(lang)
            localStorage.setItem('language', lang)
        },
    },
    methods: {
        goToPage(link) {
            this.$router.push(`/${link}`)
            this.menuToggler()
        },
		setActiveLanguage(lang) {
			this.activeLanguage = lang
        },
        setInitialValue() {
            const storedLanguage = localStorage.getItem('language')
            this.activeLanguage = storedLanguage
        }
    }
}

</script>

<style lang="scss" scoped>

.SideMenuLinks {
    position: absolute;
    background: whitesmoke;
    height: 100%;
    width: 100%;
    right: -100vw;
    top: 0;
    bottom: 0;
    padding: 20px 25px;
    transition: 0.3s;

	@media screen and (min-width: 375px) {
		width: 80%;
	}
	@media screen and (min-width: 425px) {
		width: 70%;
	}
	@media screen and (min-width: 768px) {
		width: 40%;
	}

	&__links {
		text-align: right;

        p {
            margin: 15px 0;
            font-size: 1.5em;
            color: $blue;
            font-weight: 600;
        }
	}

	&__lang {
		padding-top: 10px;
		display: flex;
		justify-content: flex-end;

		div	 {
			width: 30px;
			height: 30px;
			margin: 0 10px;

			&:last-child {
				margin-right: 0;
			}

			img {
				width: 100%;
				height: 100%;
				filter: grayscale(100%);
			}
		}
	}
}

.menuActive {
    right: 0;
    transition: 0.3s;
}

.activeLang {
	img {
		filter: grayscale(0%) !important;
	}
}
</style>
